import React from 'react'
import { Box, Breadcrumbs, Link, Typography } from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import HomeIcon from '@mui/icons-material/Home'

interface BreadcrumbItem {
    label: string
    href?: string
    isCurrentPage?: boolean
}

interface BreadcrumbsComponentProps {
    items: BreadcrumbItem[]
    locale: string
    homeLabel: string
}

const BreadcrumbsComponent: React.FC<BreadcrumbsComponentProps> = ({ 
    items, 
    locale, 
    homeLabel 
}) => {
    return (
        <Box 
            sx={{ 
                py: { xs: 1.5, sm: 2 },
                bgcolor: { xs: 'grey.50', sm: 'transparent' },
                borderBottom: { xs: '1px solid', sm: 'none' },
                borderColor: 'divider'
            }}
        >
            <Breadcrumbs 
                separator={<NavigateNextIcon fontSize="small" sx={{ color: 'text.secondary' }} />}
                aria-label="breadcrumb"
                sx={{
                    '& .MuiBreadcrumbs-separator': {
                        mx: { xs: 0.5, sm: 1 }
                    }
                }}
            >
                <Link
                    href={`/${locale}`}
                    underline="hover"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        color: 'text.secondary',
                        fontSize: { xs: '0.813rem', sm: '0.875rem' },
                        '&:hover': {
                            color: 'primary.main'
                        }
                    }}
                >
                    <HomeIcon sx={{ mr: 0.5, fontSize: { xs: 16, sm: 18 } }} />
                    {homeLabel}
                </Link>
                
                {items.map((item, index) => {
                    const isLast = index === items.length - 1
                    
                    if (isLast || item.isCurrentPage) {
                        return (
                            <Typography
                                key={index}
                                sx={{
                                    fontSize: { xs: '0.813rem', sm: '0.875rem' },
                                    fontWeight: 600,
                                    color: 'primary.main'
                                }}
                            >
                                {item.label}
                            </Typography>
                        )
                    }
                    
                    return (
                        <Link
                            key={index}
                            href={item.href || '#'}
                            underline="hover"
                            sx={{
                                color: 'text.secondary',
                                fontSize: { xs: '0.813rem', sm: '0.875rem' },
                                '&:hover': {
                                    color: 'primary.main'
                                }
                            }}
                        >
                            {item.label}
                        </Link>
                    )
                })}
            </Breadcrumbs>
        </Box>
    )
}

export { BreadcrumbsComponent }
export type { BreadcrumbsComponentProps, BreadcrumbItem }